import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;
const API_URL_TOOL = process.env.VUE_APP_BASE_API_URL_OSINT;


class NlpService {
    searchLang(ip, params) {
        return axios.get(ip + 'langid', { headers: { 'Content-Type': 'application/json' }, params: params, });
    }
    entityExtraction(ip, data) {
        return axios.post(ip + 'polyglot/entities', data, { headers: { 'Content-Type': 'application/json' }, params: data, });
    }
    searchNews(ip, params) {
        return axios.get(ip + 'newspaper', { headers: { 'Content-Type': 'application/json' }, params: params, });
    }
    searchSentiment(ip, data) {
        return axios.post(ip + 'polyglot/sentiment', data, { headers: { 'Content-Type': 'application/json' }, params: data, });
    }
    searchEmbeddings(ip, params) {
        return axios.get(ip + 'polyglot/neighbours', { headers: { 'Content-Type': 'application/json' }, params: params, });
    }
    // searchSummarize(ip, params) {
    //     return axios.post(ip + 'gensim/summarize', { headers: { 'Content-Type': 'application/json' } });
    // }
}

export default new NlpService();
